/* =============================================================================
Search Form
============================================================================= */

// eslint-disable-next-line space-before-function-paren
(function() {
    const searchBtn = document.getElementById('search-btn');
    const searchBtnClose = document.getElementById('search-btn-close');
    const searchForm = document.getElementById('searchform');
    const searchInput = document.getElementById('s');

    searchBtn.addEventListener('click', function() {
        searchForm.classList.add('expanded');
    });

    searchBtnClose.addEventListener('click', function() {
        searchForm.classList.remove('expanded');
        searchInput.value = '';
    });
})();
